import { CreateColaborator, Colaborator, UpdateColaborator } from '@/entities/colaborator';
import { Api } from './api/axios-config';

export class ColaboratorService {
  private static api = Api();

  public static async getAllColaborator(): Promise<Colaborator[] | null> {
    try {
      const response = await this.api.get<any>('/Collab');

      // Verifica se a resposta contém um array de dados
      if (response.status === 200) {
        const collaborator = response.data.collaborators.map((data: any) => ({
          id: data.id,
          name: data.name,
          isAdmin: data.isAdmin,
          cellPhone: data.cellPhone,
          whatsapp: data.whatsapp,
          company: data.company,
          email: data.email,
          companyId: data.companyId // Inclua se precisar destas propriedades
        }));

        return collaborator;
      } else {
        console.error('Erro: A resposta da API não contém um array válido:', response.data);
      }
      return null;
    } catch (error) {
      console.error('Erro ao buscar colaboradores:', error);
      return null;
    }
  }

  public static async getNotLinkedCollaborators(): Promise<Colaborator[] | undefined> {
    const response = await this.api.get('linkCollab');
    if (response.status === 200) {
      const collaborator = response.data.collaborators.map((data: any) => ({
        id: data.id,
        name: data.name,
        isAdmin: data.isAdmin,
        cellPhone: data.cellPhone,
        whatsapp: data.whatsapp,
        email: data.email,
        companyId: data.companyId // Inclua se precisar destas propriedades
      }));

      return collaborator;
    }
  }

  public static async getAllAdmin(): Promise<Colaborator[] | undefined> {
    const response = await this.api.get<any>('admins');
    if (response.status === 200) {
      return response.data;
    }
    return;
  }


  public static async createColaborator(colaborator: CreateColaborator): Promise<Colaborator | null> {
    const response = await this.api.post<any>('/Collab', {
      name: colaborator.name,
      email: colaborator.email,
      cellPhone: colaborator.cellPhone,
      whatsapp: colaborator.whatsapp,
      companyId: colaborator.companyId,
    });
    if (response.status === 201) {
      return {
        id: response.data.id,
        name: response.data.name,
        email: response.data.email,
        companyId: response.data.companyId,
      };
    }
    return null;
  }

  public static async updateColaborator(colaboratorId: number, colaborator: UpdateColaborator): Promise<Colaborator | null> {
    const response = await this.api.patch<any>(`/Collab/update/${colaboratorId}`, {
      name: colaborator.name,
      email: colaborator.email,
      isAdmin: colaborator.isAdmin,
      whatsapp: colaborator.whatsapp,
      cellPhone: colaborator.cellPhone,
    });
    if (response.status === 201) {
      return response.data;
    }
    return null;
  }

  public static async deleteColaborator(id: number): Promise<Colaborator | null> {
    const response = await this.api.delete<any>(`/Collab/${id}`);
    if (response.status === 200) {
      return {
        id: response.data.id,
        name: response.data.name,
        email: response.data.email,
        companyId: response.data.companyId,
      };
    }
    return null;
  }
}
